import moment from 'moment';


export const findFlight = (id, allFlights) => {
  const flight = allFlights.find((flight) => flight?.id === id);

  return flight;
};


// Retention window helpers (72h back, 2 days ahead; UTC)
const getRetentionWindow = () => {
  const nowUtc = moment.utc();
  return {
    earliest: moment.utc(nowUtc).subtract(72, 'hours'),
    latest: moment.utc(nowUtc).add(2, 'days').endOf('day'),
  };
};

export const filterFlightsInRetentionWindow = (flights) => {
  const { earliest, latest } = getRetentionWindow();
  return (Array.isArray(flights) ? flights : []).filter((f) => {
    const std = f?.departureDateTime ? moment.utc(f.departureDateTime) : null;
    return std && std.isSameOrAfter(earliest) && std.isSameOrBefore(latest);
  });
};

export const hasFlightsNext14h = (flights) => {
  const nowUtc = moment.utc();
  const next14h = moment.utc(nowUtc).add(14, 'hours');
  return (flights || []).some((f) => {
    const std = f?.departureDateTime ? moment.utc(f.departureDateTime) : null;
    return std && std.isSameOrAfter(nowUtc) && std.isSameOrBefore(next14h);
  });
};

export const hasFlightsLast72h = (flights) => {
  const nowUtc = moment.utc();
  const last72h = moment.utc(nowUtc).subtract(72, 'hours');
  return (flights || []).some((f) => {
    const std = f?.departureDateTime ? moment.utc(f.departureDateTime) : null;
    return std && std.isBefore(nowUtc) && std.isSameOrAfter(last72h);
  });
};

// Returns the id of the most recent past flight before now (UTC)
export const getMostRecentPastFlightId = (flights) => {
  const nowUtc = moment.utc();
  const past = (Array.isArray(flights) ? flights : [])
    .map((f) => {
      const std = f?.departureDateTime ? moment.utc(f.departureDateTime) : null;
      return std ? { id: f?.id, std } : null;
    })
    .filter((x) => !!x && x.std.isBefore(nowUtc))
    .sort((a, b) => b.std.valueOf() - a.std.valueOf());

  return past[0]?.id || '';
};

// Returns the id of the first flight whose STD is at or after now (UTC)
export const getFirstActiveFlightId = (flights) => {
  const nowUtc = moment.utc();
  const firstActive = (Array.isArray(flights) ? flights : []).find((f) => {
    const std = f?.departureDateTime ? moment.utc(f.departureDateTime) : null;
    return std && std.isSameOrAfter(nowUtc);
  });
  return firstActive?.id || '';
};

// Returns the id of the upcoming flight with the earliest STD at or after now (UTC)
export const getNextUpcomingFlightId = (flights) => {
  const nowUtc = moment.utc();
  const upcoming = (Array.isArray(flights) ? flights : [])
    .map((f) => {
      const std = f?.departureDateTime ? moment.utc(f.departureDateTime) : null;
      return std ? { id: f?.id, std } : null;
    })
    .filter((x) => !!x && x.std.isSameOrAfter(nowUtc))
    .sort((a, b) => a.std.valueOf() - b.std.valueOf());

  return upcoming[0]?.id || '';
};

// Returns upcoming flights (objects) sorted by STD ascending, at or after now (UTC)
export const getNextUpcomingFlights = (flights) => {
  const nowUtc = moment.utc();
  return (Array.isArray(flights) ? flights : [])
    .map((f) => {
      const std = f?.departureDateTime ? moment.utc(f.departureDateTime) : null;
      return std ? { flight: f, std } : null;
    })
    .filter((x) => !!x && x.std.isSameOrAfter(nowUtc))
    .sort((a, b) => a.std.valueOf() - b.std.valueOf())
    .map((x) => x.flight);
};
